

const PercChart = ({ percentage }) => {
  const viewBox = "0 0 100 100";
  const passedColor = "#36A2EB";
  const failedColor = "#FF6384";

  // Calculate angles for the pie chart segments
  const passedAngle = (percentage / 100) * 360;
  const failedAngle = (1 - percentage / 100) * 360;

  return (
    <svg viewBox={viewBox} width="200" height="200">
      {/* Passed percentage segment */}
      <path
        d={`M50,50 L50,0 A50,50 1 ${passedAngle > 180 ? 1 : 0},1 ${Math.cos((passedAngle - 90) * Math.PI / 180) * 50 + 50},${Math.sin((passedAngle - 90) * Math.PI / 180) * 50 + 50} Z`}
        fill={passedColor}
      />

      {/* Failed percentage segment */}
      <path
        d={`M50,50 L${50 + Math.cos((passedAngle - 90) * Math.PI / 180) * 50},${50 + Math.sin((passedAngle - 90) * Math.PI / 180) * 50} A50,50 0 ${failedAngle > 180 ? 1 : 0},1 ${Math.cos((passedAngle + failedAngle - 90) * Math.PI / 180) * 50 + 50},${Math.sin((passedAngle + failedAngle - 90) * Math.PI / 180) * 50 + 50} Z`}
        fill={failedColor}
      />

      {/* Center circle */}
      <circle cx="50" cy="50" r="35" fill="rgba(0, 0, 0, 0.8)" />

      {/* Text for displaying percentage */}
      <text x="50" y="50" textAnchor="middle" dominantBaseline="middle" fontSize="14" fontWeight="bold" fill="#87CEFA">
        {`${percentage}%`}
      </text>
    </svg>
  );
};

export default PercChart;
